// Charting - HighCharts
//  https://www.highcharts.com/
import Vue from 'vue'

// wrapper
// https://github.com/weizhenye/vue-highcharts
import VueHighcharts from 'vue-highcharts'

// charting
import Highcharts from 'highcharts'

// modules
import drilldown from 'highcharts/modules/drilldown.js'
import exporting from 'highcharts/modules/exporting'
import exportdata from 'highcharts/modules/export-data'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'

drilldown(Highcharts)
exporting(Highcharts)
exportdata(Highcharts)
highchartsMore(Highcharts)
solidGauge(Highcharts)

Highcharts.setOptions({
  chart: {
    /* X axis zoon */
    zoomType: 'x',
    borderWidth: 0,
    resetZoomButton: {
      position: {
        align: 'left',
        verticalAlign: 'top',
        x: 0,
        y: 0
      },
      theme: {
        fill: '#D32F2F',
        r: 5,
        style: {
          color: '#FFFFFF'
        },
        states: {
          hover: {
            fill: '#333333',
            style: {
              color: '#FFFFFF'
            }
          }
        }
      },
      relativeTo: 'chart'
    }
  },
  /* context menu exports */
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        enabled: true,
        menuItems: [
          'downloadCSV',
          'downloadXLS',
          'separator',
          'downloadPDF',
          'downloadPNG',
          'downloadJPEG',
          'separator',
          'printChart'
        ]
      }
    }
  },
  /* sorry highcharts ... */
  credits: {
    enabled: false
  },
  /* common legend location under x-axis */
  legend: {
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    borderWidth: 0,
    itemStyle: {
      font: '9pt Trebuchet MS, Verdana, sans-serif',
      color: 'black'
    },
    itemHoverStyle: {
      color: '#039'
    },
    itemHiddenStyle: {
      color: 'gray'
    }
  },
  /* styling */
  title: {
    style: {
      color: '#111',
      fontWeight: 'bold',
      fontFamily: '16px "Trebuchet MS", Verdana, sans-serif'
    }
  },
  subtitle: {
    style: {
      color: '#666',
      fontSize: '12px',
      fontFamily: '"Trebuchet MS", Verdana, sans-serif'
    }
  },
  xAxis: {
    // gridLineWidth: 1,
    lineColor: '#aaa',
    tickColor: '#aaa',
    labels: {
      style: {
        fontSize: '11px',
        fontFamily: '"Trebuchet MS", Verdana, sans-serif'
      }
    },
    title: {
      style: {
        color: '#333',
        fontWeight: 'bold',
        fontSize: '12px',
        fontFamily: '"Trebuchet MS", Verdana, sans-serif'
      }
    }
  },
  yAxis: {
    minorTickInterval: 'auto',
    lineColor: '#aaa',
    lineWidth: 1,
    tickWidth: 1,
    tickColor: '#aaa',
    labels: {
      style: {
        fontSize: '11px',
        fontFamily: '"Trebuchet MS", Verdana, sans-serif'
      }
    },
    title: {
      style: {
        color: '#333',
        fontWeight: 'bold',
        fontSize: '12px',
        fontFamily: 'Trebuchet MS, Verdana, sans-serif'
      }
    }
  },
  labels: {
    style: {
      color: '#99b'
    }
  }
})

// Theme
// import gridLightTheme from 'highcharts/themes/grid-light'
// Highcharts.theme = gridLightTheme
// Highcharts.theme = {
//   colors: [
//     '#058DC7',
//     '#50B432',
//     '#ED561B',
//     '#DDDF00',
//     '#24CBE5',
//     '#64E572',
//     '#FF9655',
//     '#FFF263',
//     '#6AF9C4'
//   ],
//   chart: {
//     // backgroundColor: {
//     //   linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
//     //   stops: [[0, 'rgb(255, 255, 255)'], [1, 'rgb(240, 240, 255)']]
//     // },
//     borderWidth: 0,
//     plotBackgroundColor: '#fafafa'
//     // plotBorderWidth: 1
//   },
//   navigation: {
//     buttonOptions: {
//       theme: {
//         stroke: '#CCCCCC'
//       }
//     }
//   }
// }

// Charting Wrapper
//  https://www.npmjs.com/package/highcharts-vue
//  https://www.highcharts.com/blog/tutorials/highcharts-vue-wrapper/
// import HighchartsVue from 'highcharts-vue'
// Vue.use(HighchartsVue)

Vue.use(VueHighcharts, { Highcharts })
